import { FormlyFieldConfig } from "@ngx-formly/core";
import { differenceInYears } from 'date-fns';
import { isNullOrUndefined } from '../../../app/core/utils';
import { ImmStatusType, StatusTypes } from '../status-types';
import { UntypedFormArray,AbstractControl } from "@angular/forms";

export function getInputField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string |null
): FormlyFieldConfig {
  return getFormlyFieldConfig("input", key, label, additionalConfig, className);
}

export function getHiddenField(
  key: string,
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    type: 'input',
    key:key,
    templateOptions: {
      type: 'hidden',
    },
  };

  return specificConfig;
}

export function getButton(
  key: string,
  label: string,
  onClickFn: Function,
  btnType: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: '',
      text: label,
      type: 'button',
      onClick: onClickFn,
      btnType: btnType,

    },
    // wrappers: ['eos-button-field-wrapper']
  };


  const genericConfig = getFormlyFieldConfig(
    "eos-button",
    null,
    null,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);

}

export function getTextArea(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    className: 'col-md-12 mb-3',
    templateOptions: {
      attributes: {
        class: 'form-control form-control-sm'
      },
      rows: 5
    }
  };

  const mergedConfig = getMergedConfig(config, additionalConfig)

  return getFormlyFieldConfig("textarea", key, label, mergedConfig, className);
}

export function getSelectField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
      attributes:{
        class:'form-select form-select-sm'
      }
    },    
    wrappers: ['copyable-field']
  };


  const genericConfig = getFormlyFieldConfig(
    "select",
    key,
    label,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}


export function getTypeAheadSelectField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      valueProp: "id",
      labelProp: "displayText",
      placeholder: "Select",
      attributes: {
        class: 'form-control form-control-sm'
      },
    }
  };

  const genericConfig = getFormlyFieldConfig(
    "typeahead-select",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getConfigurableTypeAhead(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  labelProp = "displayText",
  valueProp = "id",
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      valueProp: valueProp,
      labelProp: labelProp,
      placeholder: "Select",
      attributes: {
        class: 'form-control form-control-sm'
      },
    }
  };

  const genericConfig = getFormlyFieldConfig(
    "config-type-ahead",
    key,
    label,
    specificConfig
  );

  return getMergedConfig(genericConfig, additionalConfig);
}

export function getButtonCombo(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: '',
    },
    wrappers: ['button-field']
  };


  const genericConfig = getFormlyFieldConfig(
    "input",
    key,
    label,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getRadioButton(key: string, label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {


  const config: FormlyFieldConfig = {
    templateOptions: {
      required: true,
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ]
    }
  };

  const genericConfig = getFormlyFieldConfig(
    "radio",
    key,
    label,
    config
  );

  return getMergedConfig(genericConfig, additionalConfig);
}

export function getCheckboxField(key: string, label: string, onChange: (obj: boolean) => void,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    templateOptions: {
      required: true,
      change: (field, $event) => { if (onChange) onChange(field.formControl.value) },
      attributes: {
        class: 'form-check-input'
      },
      
    },
    className: 'col-md-4 mb-3 formly-checkbox-mt',
   
  };

  const genericConfig = getTemplateFormlyFieldConfig(
    "checkbox",
    key,
    label,
    config
  );

  return getMergedConfig(genericConfig, additionalConfig);
}

export function getBigFourExpCheckboxNonMandatory(key: string, label: string, onChange: (obj: boolean) => void,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    templateOptions: {
      required: false,
      change: (field, $event) => { if (onChange) onChange(field.formControl.value) },
      attributes: {
        class: 'custom-control-input'
      },
      click : (field, event) => {
        setTimeout(() => {
          let val = field.formControl.value;
          const myFormArray = field.form.parent as UntypedFormArray;
          let currentlyEmployedCount = myFormArray.value.filter(x=>x['bigFourcurrentlyEmployed']==true).length;
          if (currentlyEmployedCount > 1) {
            myFormArray.controls.forEach(x => {
              x.get('bigFourcurrentlyEmployed').setValue(false);
              x.get('bigFourendDate').enable();
            })
          }
          field.formControl.setValue(val);
          if (val == true) {
            field.formControl.parent.get('bigFourendDate').disable();
            field.formControl.parent.get('bigFourendDate').setValue(null);
          }
          else {
            field.formControl.parent.get('bigFourendDate').enable();
             }
        }, 100);
      }
    },
    className: 'col-md-4 mb-3 formly-checkbox-mt'
  };

  const genericConfig = getTemplateFormlyFieldConfig(
    "checkbox",
    key,
    label,
    config
  );

  return getMergedConfig(genericConfig, additionalConfig);
}
export function getAttachemntField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  return getFormlyFieldConfig("file", key, label, additionalConfig, className);
}

export function getDateField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
  ): FormlyFieldConfig {
  return getFormlyFieldConfig("datepicker", key, label, additionalConfig, className);
}

export function getDateTimeField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  return getFormlyFieldConfig("date-time", key, label, additionalConfig, className);
}

export function getTelephoneField(
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string | null,
  phoneKey = "phoneNumber",
  codeKey = "countryCode",
  requried = true
): FormlyFieldConfig {

  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      phoneKey: phoneKey,
      codeKey: codeKey,
      required: requried
    }
  };
  const mergedConfig = getMergedConfig(specificConfig, additionalConfig);

  return getFormlyFieldConfig("phone-field", null, label, mergedConfig, className);
}

export function getCurrencyField(
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string,
  amountKey = "amount",
  currencyKey = "currencyCode",
  requried = true
): FormlyFieldConfig {

  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      amountKey: amountKey,
      currencyKey: currencyKey,
      required: requried
    }
  };
  const mergedConfig = getMergedConfig(specificConfig, additionalConfig);

  return getFormlyFieldConfig("currency-field", null, label, mergedConfig, className);
}



export function getTypeAheadField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      placeholder: "Select",
      attributes: {
        class: 'form-control form-control-sm'
      }
    }
  };

  const genericConfig = getFormlyFieldConfig(
    "ad-typeahead",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getTypeAheadFieldWithDisplayText(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      placeholder: "Select",
      attributes: {
        class: 'form-control form-control-sm'
      }
    }
  };

  const genericConfig = getFormlyFieldConfig(
    "ad-typeahead-with-displayText",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getTeplateSelectField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
    },
    // wrappers: ['copyable-field']
  };


  const genericConfig = getFormlyFieldConfig(
    "template-select",
    key,
    label,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}
export function getExitTemplateSelectField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
    },
    // wrappers: ['copyable-field']
  };


  const genericConfig = getFormlyFieldConfig(
    "template-select-exit",
    key,
    label,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getEmpProfileSelectField(
  key: string,
  label: string,
  operation: () => string[],
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
      onSelect: operation


    },

    // wrappers: ['copyable-field']
  };


  const genericConfig = getFormlyFieldConfig(
    "employee-select",
    key,
    label,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function getTemplateFormlyFieldConfig(
  type?: string,
  key?: string,
  label?: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    className: className ? className : 'col-md-4 mb-3',
    defaultValue: type=='checkbox'? false:null,
    templateOptions: {
      attributes: {
        class: 'form-control form-control-sm'
      },
    }
  };
  if (type) {
    config.type = type;
  }
  if (key) {
    config.key = key;
  }
  if (label) {
    config.templateOptions.label = label;
  }

  return getMergedConfig(config, additionalConfig);
}


export function getFormlyFieldConfig(
  type?: string,
  key?: string,
  label?: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    className: className ? className : 'col-md-4 mb-3',
    templateOptions: {
      attributes: {
        class: 'form-control form-control-sm'
      },
    }
  };
  if (type) {
    config.type = type;
  }
  if (key) {
    config.key = key;
  }
  if (label) {
    config.templateOptions.label = label;
  }

  return getMergedConfig(config, additionalConfig);
}

export function getMergedConfig(
  config: FormlyFieldConfig,
  additionalConfig: FormlyFieldConfig
) {
  const result = { ...config, ...additionalConfig };
  if (additionalConfig && additionalConfig.templateOptions) {
    result.templateOptions = {
      ...config.templateOptions,
      ...additionalConfig.templateOptions
    };
  }

  if (additionalConfig && additionalConfig.expressionProperties) {
    result.expressionProperties = {
      ...config.expressionProperties,
      ...additionalConfig.expressionProperties
    };
  }
  if (additionalConfig && additionalConfig.validators) {
    result.validators = {
      ...config.validators,
      ...additionalConfig.validators
    };
  }
  if (additionalConfig && additionalConfig.asyncValidators) {
    result.asyncValidators = {
      ...config.asyncValidators,
      ...additionalConfig.asyncValidators
    };
  }
  if (additionalConfig && additionalConfig.wrappers && config.wrappers) {
    result.wrappers = [...additionalConfig.wrappers, ...config.wrappers]
  }

  return result;
}
export function setDateFieldValueAndDisableBasedOnCondition(
  field: FormlyFieldConfig,
  targetFieldKey: string,
  condition: (model: any) => boolean,
  valueToSet: any
): FormlyFieldConfig {
  const existingExpressions = field.expressionProperties || {};

  return {
    ...field,
    expressionProperties: {
      ...existingExpressions,


      [`model.${targetFieldKey}`]: (model: any) => {
        if (condition(model)) {
          let value =
            typeof valueToSet === 'function' ? valueToSet(model) : valueToSet;

          if (value && !(value instanceof Date)) {
            value = new Date(value);
          }

          return value;
        }
        return model[targetFieldKey];
      },

      [`templateOptions.disabled`]: (model: any, formState: any, f: FormlyFieldConfig) => {
        if (f.key === targetFieldKey) {
          return condition(model);
        }
        return f.templateOptions?.disabled ?? false;
      },
    },
  };
}



export function setFieldValueAndDisableBasedOnCondition(
  targetFieldKey: string,
  condition: (model: any) => boolean,
  valueToSet: any
): { expressionProperties: { [key: string]: (model: any, formState: any, field: FormlyFieldConfig) => any } } {
  return {
    expressionProperties: {
      // Set the value of the target field based on the condition
      [`model.${targetFieldKey}`]: (model: any, formState: any, field: FormlyFieldConfig) => {
        if (condition(model)) {
          return valueToSet;
        }
        return model[targetFieldKey];
      },
      // Disable the target field based on the condition
      [`templateOptions.disabled`]: (model: any, formState: any, field: FormlyFieldConfig) => {
        if (field.key === targetFieldKey) {
          return condition(model);
        }
        return field.templateOptions.disabled;
      }
    }
  };
}


export function setAsRequired(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      required: true,
    },
    validators: {
      validation: ['blankSpace']
    }
  };

  return getMergedConfig(config, additionalConfig);
}

export function setAsRequiredForNotApplicable(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    expressionProperties: {
      'templateOptions.required': (model, formState, field) => {
        const notApplicable = field?.templateOptions?.__notApplicable === true;
        return !notApplicable; // Always required unless marked Not Applicable
      }
    },
    validators: {
      validation: ['blankSpace']
    }
  };

  return getMergedConfig(additionalConfig ?? {}, config);
}

export function setAsRequiredEmail(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      required: true,
    },
    validators: {
      validation: ['email'],
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function EmailValidator(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {

    validators: {
      validation: ['email'],
    },
  };

  return getMergedConfig(config, additionalConfig);
}




export function setAsNumeric(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      validation: ['integer'],
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function setAsNumericWithNA(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      validation: ['integerwithNA'],
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function checkRangewithNA(minVal: number, maxVal: number, message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          const num = Number(c.value);
          if (Number.isNaN(num)) {
            return false;
          }
          if (num <= minVal || num > maxVal || !Number.isInteger(num)) {
            return false;
          }

          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function checkRange(minVal: number, maxVal: number, message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (isNullOrUndefined(c.value)) {
            return true;
          }

          if (!isNullOrUndefined(c.value) && c.value >= minVal && c.value <= maxVal) {
            return true;
          }
          return false;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function setRequiredAndDisabledBasedOnNationalityType(nationalIdForDisable: number, fieldKey: string = 'visaExpiryDate') {
 return {
   // Disable ONLY for specific nationality
   'templateOptions.disabled': (_model, _formState, field) => {
     const nationalityId = field?.parent?.model?.nationalityType?.id;
     return nationalityId === nationalIdForDisable;
   },
   // Required ONLY when enabled
   'templateOptions.required': (_model, _formState, field) => {
     const nationalityId = field?.parent?.model?.nationalityType?.id;
     return nationalityId !== nationalIdForDisable;
   },
   // Clear value when disabled
   [`model.${fieldKey}`]: (_model, _formState, field) =>
     field?.parent?.model?.nationalityType?.id === nationalIdForDisable
       ? null
       : field?.model?.[fieldKey],
 };
}

export function setRegexValidation(exp: RegExp, message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (c.value && c.value.length > 0) {
            return exp.test(c.value);
          }
          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}
export function setRegexValidationWhen(
  regex: RegExp,
  message: string,
  conditionFn: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig // Optional additional configurations
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {}, // Default empty templateOptions
    validators: {
      conditionalRegex: {
        expression: (c: AbstractControl, field: FormlyFieldConfig) => {
          const model = field.model; // Get model from field context
          if (conditionFn(model)) {
            return c.value ? regex.test(c.value) : true; // Apply regex validation only if the condition is met
          }
          return true; // If condition is not met, always return valid
        },
        message: () => message,
      },
    },
  };

  return getMergedConfig(config, additionalConfig);
}



export function setStatusTypeValidation(message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (c.value === StatusTypes.APPROVED) {
            return false;
          }
          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}
export function setImmStatusTypeValidation(message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (c.value === ImmStatusType.ACCEPTED) {
            return false;
          }
          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function setStatusNotAllowed(statusId: any, message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (c.value === statusId) {
            return false;
          }
          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function setType(type: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      type
    }
  };
  return getMergedConfig(config, additionalConfig);
}

export function setTypeandRequired(type: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      type,
      required: true
    }
  };
  return getMergedConfig(config, additionalConfig);
}
export function setYesNoValues(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      required: true,
      options: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ],
    },
  };

  return getMergedConfig(config, additionalConfig);
}

// export function setDisableWhen(
//   func: (model: any) => boolean,
//   additionalConfig?: FormlyFieldConfig
// ): FormlyFieldConfig {
//   const config: FormlyFieldConfig = {
//     templateOptions: {
//     },
//     expressionProperties: {
//       'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
//         let disable = func(model);
//          // skip disable until field has a value set
//          if (field.formControl && field.formControl.value == null) {
//           return false;
//         }
//         if (disable && field.formControl.value !== null) {
//           field.formControl.setValue(null);
//         }
//         const form = field.parent.formControl;
//         if (!form.disabled) {
//           return disable;
//         }
//         return form.disabled;
//       }
//     }
//   };

//   return getMergedConfig(config, additionalConfig);
// }
export function setDisableWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {},
    hooks: {
      onInit: (field) => {
        field.props._wasDisabled = func(field.model);
      }
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
        const shouldDisable = func(model);
        const wasDisabled = field.props._wasDisabled;
        // Only clear the value if transitioning from enabled to disabled
        if (shouldDisable && !wasDisabled && field.formControl?.value !== null) {
          field.formControl.setValue(null);
        }        
        // Update the previous state
        field.props._wasDisabled = shouldDisable;
        return shouldDisable;
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

export function setHideButtonWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
      let disable = func(model);
      return disable;
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function setDisablePhoneFieldWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {

        let disable = func(model);
        if (field.type == 'phone-field' && field.fieldGroup) {
          field.fieldGroup.forEach(x => {
            //if form already disabled dont do anything
            if (x.formControl.disabled === false) {
              x.templateOptions.disabled = disable;
            }
            // if (disable) {
            //   x.formControl.setValue(null);
            // }
          })
          return disable;
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

export function setOMNPhoneFieldDisableWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {

        let disable = func(model);
        if (field.type == 'phone-field' && field.fieldGroup) {
          field.fieldGroup.forEach(x => {
              console.log(field)
              x.templateOptions.disabled = disable;
          })
          return disable;
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

export function setDisableCurrencyFieldWhen(
  func: (model: any) => boolean,
  amountkey: string,
  currencyKey: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {

        let disable = func(model);
        if (field.type == 'currency-field' && field.fieldGroup) {
          const form = field.parent.formControl;
          field.fieldGroup.forEach(x => {
            if (x.key == amountkey || x.key == currencyKey) {
              if (disable) {
                x.formControl.setValue(null);
              }
              //if form already disabled dont do anything
              if (!form.disabled) {
                x.templateOptions.disabled = disable;
                return disable;
              }
            }

          })
          return form.disabled;
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

// export function setDisablewithValueWhen1(
//   func: (model: any) => boolean,
//   additionalConfig?: FormlyFieldConfig,
//   checkFormPristine = false
// ): FormlyFieldConfig {
//   const config: FormlyFieldConfig = {
//     templateOptions: {
//     },
//     expressionProperties: {
//       'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
//          let disable = func(model);
//                 // skip disable until field has a value set
//         if (field.formControl && field.formControl.value == null) {
//           return false;
//         }
 
       
//         const form = field.parent.formControl;
//         if (!form.disabled) {
//           if (checkFormPristine) {
//             return disable && !field.formControl.dirty;
//           }
//           return disable;
//         }
//         return form.disabled;
//       }
//     }
//   };

//   return getMergedConfig(config, additionalConfig);
// }

export function setDisablewithValueWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig,
  checkFormPristine = false
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
      hooks: {
      onInit: (field) => {
        field.props._wasDisabled = func(field.model);
      }
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
        // skip disable until field has a value set
        // if (field.formControl && field.formControl.value == null) {
        //   return false;
        // }
 
        const shoulddisable = func(model);
        const wasDisabled = field.props._wasDisabled;
        // if (!checkFormPristine && shoulddisable && !wasDisabled && field.formControl?.value !== null) {
        //   field.formControl.setValue(null);
        // }       
        const form = field.parent.formControl;
        if (!form.disabled) {
          if (checkFormPristine) {
            return shoulddisable && !field.formControl.dirty;
          }
          return shoulddisable;
        }
        return form.disabled;
      }
    }
  };
 
  return getMergedConfig(config, additionalConfig);
}


export function setAsDisabled(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      disabled: true
    }
  };
  return getMergedConfig(config, additionalConfig);
}
export function setAsReadOnlyRequiredWhen(
  func: (model: any) => boolean,additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      readonly: true     
    },
    expressionProperties: {
      'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
        return func(model);
    } 
     },
  };
  return getMergedConfig(config, additionalConfig);
}
export function setAsHiddenWhen(condition: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
      return condition(model);
    }
  };
  return getMergedConfig(config, additionalConfig);
}

export function setAsHiddenWithoutValueWhen(condition: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
      if (condition(model)) {
          field.formControl.setValue(null)
        }
      return condition(model);
    }
  };
  return getMergedConfig(config, additionalConfig);
}
export function setAsDisabledWhenWithOutVal(condition: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {

    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
        if (condition(model)) {
          field.formControl.setValue(null)
        }
        return condition(model)
      }
    }
  };
  return getMergedConfig(config, additionalConfig);
}
export function setAsDisabledWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    templateOptions: {
    },

    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {

        return func(model)
      },
    }

  };

  return getMergedConfig(config, additionalConfig);
}



export function setRequiredWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    expressionProperties: {
      'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
        return func(model);
      },
    }

  };

  return getMergedConfig(config, additionalConfig);
}



export function setRequiredForNotApplicableWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const requiredConfig: FormlyFieldConfig = {
    expressionProperties: {
      'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
        const notApplicable = field?.templateOptions?.__notApplicable === true;
        return !notApplicable && func(model);
      },
    },
  };

  // Merge *additionalConfig first*, then overlay our required expression
  // so it reliably wins on the final object.
  return getMergedConfig(additionalConfig ?? {}, requiredConfig);
}

export function setPlaceholderNotApplicableWhen(
  conditionFn: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    expressionProperties: {
        'templateOptions.__notApplicable': (model) => conditionFn(model),
      'templateOptions.placeholder': (model, formState, field) => {
        if (conditionFn(model)) return 'Not Applicable';
        // Default placeholder based on type
        switch (field.type) {
          case 'select':
          case 'typeahead-select':
          case 'ad-typeahead':
          case 'config-type-ahead':
          case 'template-select':
          case 'template-select-exit':
          case 'employee-select':
          case 'multi-select':
          case 'typeahead-select-airport':
          case 'typeahead-select-locations':
          case 'typeahead-select-employee':
            return 'Select';
          case 'datepicker':
          case 'date-time':
            return 'DD-MM-YY';
          case 'input':
          case 'textarea':
          default:
            return '';
        }
      },
       'templateOptions.required': (model, formState, field) => {
         const originalRequired = field.templateOptions?.required ?? false;
         return conditionFn(model) ? false : originalRequired;
       }
    }
  };

  return getMergedConfig(config, additionalConfig);
}


export function MinumumAgeMustBe(years: number, message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (!isNullOrUndefined(c.value)) {
            const diff = c.value.getTime() - new Date().getTime();
            const d = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
            return d <= -(years);
          }
          return false;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function MinMaxAgeMustBe(
  minYears: number,
  maxYears: number,
  message: string,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (isNullOrUndefined(c.value)) {
            return true;
          }
          if (!isNullOrUndefined(c.value)) {
            const datediff = differenceInYears(c.value, new Date());
            // d negative int because of dob being less than current date.
            // not making it +ve since easy to understand it as negative int.
            return (datediff <= 0 && datediff <= -minYears && datediff >= -maxYears);
          }
          return false;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}

export function ValidateFutureDate(
  message: string,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      vname: {
        expression: (c) => {
          if (!isNullOrUndefined(c.value)) {

            return (c.value < new Date());
          }
          return false;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };

  return getMergedConfig(config, additionalConfig);
}


export function getArrayPickerField(
  key: string,
  label: string,
  _fieldsSet: FormlyFieldConfig[],
  _title: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string|null,
  _displayButtonName?: string | null,
  _isRequired?: boolean  | null,
  _subTitle?: string,
  _immUserProfileView?: boolean,
  _nonDependent?: boolean,
  _isIBM?:boolean
  
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Picker",
      fieldsSet: _fieldsSet,
      title: _title,
      btnName: _displayButtonName,
      isRequired: _isRequired,
      subTitle:_subTitle,
      immUserProfileView:_immUserProfileView,
      nonDependent:_nonDependent,
      isIBM :_isIBM
    },
  };


  const genericConfig = getFormlyFieldConfig(
    "array-picker",
    key,
    label,
    specificConfig,
    className
  );

  return getMergedConfig(genericConfig, additionalConfig);
}

export function getAdditinalInfoPickerField(
  key: string,
  label: string,
  // _fieldsSet: StepTypeExit[],
  _title: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Picker",
      // fieldsSet: _fieldsSet,
      title: _title
    },
  };


  const genericConfig = getFormlyFieldConfig(
    "additional-info-picker",
    key,
    label,
    specificConfig,
    className
  );

  return getMergedConfig(genericConfig, additionalConfig);
}
export function getAdditinalTeamInfoPickerField(
  key: string,
  label?: string,
  // _fieldsSet: StepTypeExit[],
  _title?: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Picker"
    },
  };


  const genericConfig = getFormlyFieldConfig(
    "team-lead-info",
    key,
    label,
    specificConfig,
    className
  );

  return getMergedConfig(genericConfig, additionalConfig);
}



export function getButtonWrapper(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
    },
    wrappers: ['eos-button-field-wrapper']
  };


  const genericConfig = getFormlyFieldConfig(
    "input",
    key,
    label,
    specificConfig,
    className
  );

  return getMergedConfig(genericConfig, additionalConfig);
}

export function getJustaButton(
  operations: () => string[],
  buttonText: string,
  btnType: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: '',
      text: buttonText,
      btnType: btnType,
      type: 'button',
      onClick: operations ? operations : () => []
    },
  };


  const genericConfig = getFormlyFieldConfig(
    "just-a-button",
    null,
    null,
    specificConfig,
    className
  );


  return getMergedConfig(genericConfig, additionalConfig);
}



export function getTypeAheadAirportSelectField(
  key: string,
  label: string,

  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      valueProp: "id",
      labelProp: "displayText",
      placeholder: "Select",
      notFoundText: 'airport not found',
      attributes: {
        class: 'form-control form-control-sm'
      },


    }
  };

  const genericConfig = getFormlyFieldConfig(
    "typeahead-select-airport",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}


export function getTypeAheadLocationSelectField(
  key: string,
  label: string,

  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      valueProp: "id",
      labelProp: "displayText",
      placeholder: "Select",
      notFoundText: 'location not found',
      attributes: {
        class: 'form-control form-control-sm'
      },
    },
   hooks: {
       onInit: (field) => {
         const value = field.formControl?.value;
         if (isNullOrUndefined(value?.id)) {
           if (field.formControl) {
            field.formControl.setValue(null);
             }         
         }
       }
     }
  };

  const genericConfig = getFormlyFieldConfig(
    "typeahead-select-locations",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}







export function getTypeAheadEmployeeSelectField(
  key: string,
  label: string,
  roleTypes: number[],
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      className: className ? className : 'col-md-4 mb-3',
      valueProp: "id",
      labelProp: "name",
      placeholder: "Select",
      notFoundText: 'Person not found',
      attributes: {
        class: 'form-control form-control-sm'
      },
      roles: roleTypes

    }
  };

  const genericConfig = getFormlyFieldConfig(
    "typeahead-select-employee",
    key,
    label,
    specificConfig
  );


  return getMergedConfig(genericConfig, additionalConfig);
}

export function selectOptionNoValidation(message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      selectedNo: {
        expression: (c, field: FormlyFieldConfig) => {
          if (!isNullOrUndefined(c.value)) {
            return c.value !== 1075;

          }
          return false;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };
  return getMergedConfig(config, additionalConfig);
}

export function selectOptionNoNaValidation(message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    validators: {
      selectedNo: {
        expression: (c, field: FormlyFieldConfig) => {
          if (!isNullOrUndefined(c.value)) {
            return c.value == 2346;
          }
          return true;
        },
        message: (error, field: FormlyFieldConfig) => message,
      }
    },
  };
  return getMergedConfig(config, additionalConfig);
}

export function setNoHarmError(
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    wrappers: ['no-harm-error']
  };
  return getMergedConfig(config, additionalConfig);
}

export function getMultiSelectField(
  key: string,
  label: string,
  additionalConfig?: FormlyFieldConfig,
  className?: string
): FormlyFieldConfig {
  const specificConfig: FormlyFieldConfig = {
    templateOptions: {
      placeholder: "Select",
      multiple: true,
      class:"filter-dropdown"
    }
  };
  const genericConfig = getFormlyFieldConfig(
    "multi-select",
    key,
    label,
    specificConfig,
    className
  );
  return getMergedConfig(genericConfig, additionalConfig);
}

export function setDisableImmigrationCaseTypeWithValueWhen(
  func: (model: any) => boolean,
  additionalConfig?: FormlyFieldConfig,
  checkFormPristine = false
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
    },
    expressionProperties: {
      'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
        // Check if the field is already disabled
        if (field.formControl.disabled) {
          return true; // Keep the field disabled
        }
        let disable = func(model);
        const form = field.parent.formControl;
        if (!form.disabled) {
          if (checkFormPristine) {
            return disable && !field.formControl.dirty;
          }
          return disable;
        }
        return form.disabled;
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}
